import constants from '@/logic/constants'

export default {
  computed: {
    $constants: () => constants,
  },
}
